import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionHead } from "./shared";
import { FAQS } from "../../data/content";

export default function Faq() {
    const [open, setOpen] = useState(0);

    return (
        <section id="faq" className="py-24 sm:py-32" data-testid="faq-section">
            <div className="container-x">
                <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12">
                    <SectionHead
                        eyebrow="11 — FAQ"
                        title="Questions, Answered."
                        sub="Everything business owners ask before hiring their AI employee."
                        testid="faq-heading"
                    />
                    <div className="flex flex-col gap-3">
                        {FAQS.map((f, i) => {
                            const isOpen = open === i;
                            return (
                                <Reveal key={f.q} delay={i * 0.04}>
                                    <div
                                        className={`glass rounded-2xl overflow-hidden transition-[border-color] duration-300 ${isOpen ? "border-cyan-400/30" : ""}`}
                                        data-testid={`faq-item-${i + 1}`}
                                    >
                                        <button
                                            className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                                            onClick={() => setOpen(isOpen ? -1 : i)}
                                            aria-expanded={isOpen}
                                            data-testid={`faq-trigger-${i + 1}`}
                                        >
                                            <span className={`text-sm sm:text-base font-semibold transition-colors duration-300 ${isOpen ? "text-cyan-200" : "text-white"}`}>
                                                {f.q}
                                            </span>
                                            <motion.span
                                                animate={{ rotate: isOpen ? 45 : 0 }}
                                                transition={{ duration: 0.3 }}
                                                className="shrink-0 text-slate-400"
                                            >
                                                <Plus className="w-5 h-5" />
                                            </motion.span>
                                        </button>
                                        <AnimatePresence initial={false}>
                                            {isOpen && (
                                                <motion.div
                                                    initial={{ height: 0, opacity: 0 }}
                                                    animate={{ height: "auto", opacity: 1 }}
                                                    exit={{ height: 0, opacity: 0 }}
                                                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                                                    className="overflow-hidden"
                                                >
                                                    <p className="px-6 pb-6 text-sm text-slate-400 leading-relaxed">{f.a}</p>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                </Reveal>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
